var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-box"},[(_vm.heading)?_c('div',{staticClass:"loading-header mb-3"},[(!_vm.noHeadingMain)?_c('div',{staticClass:"loading-heading"}):_vm._e(),_c('div',{staticClass:"loading-text-line"}),_c('div',{staticClass:"loading-text-line"})]):_vm._e(),(_vm.paragraphs > 0)?_c('div',{class:{
    'loading-body': _vm.box,
    'bs': _vm.box
    }},_vm._l((_vm.paragraphs),function(paragraph){return _c('div',{key:paragraph,staticClass:"loading-body-cell"},_vm._l((_vm.lines),function(line){return _c('div',{key:line,class:{
        'loading-text-line': true,
        'loading-text-line-big': _vm.bigLines
        }})}),0)}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }